import React, { useState } from 'react';
import {
  Box,
  Button,
  Container,
  Grid,
  TextField,
  Typography,
  InputAdornment,
  Paper,
  IconButton
} from '@mui/material';
import BadgeIcon from '@mui/icons-material/Badge';
import LockIcon from '@mui/icons-material/Lock';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from 'react-router-dom';
import Navbar from '../Navbar'; // Assuming you have a Navbar component

const PRIMARY_COLOR = '#616161';

const ResellerLoginPage = () => {
  const [formData, setFormData] = useState({
    resellerId: '',
    password: ''
  });

  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const togglePasswordVisibility = () => {
    setShowPassword((prev) => !prev);
  };
const handleLogin = async (e) => {
  e.preventDefault();

  const { resellerId, password } = formData;
  if (!resellerId || !password) {
    setError('Please fill in all fields');
    return;
  }

  try {
    const response = await fetch('https://reviewhub-lc.onrender.com/api/resellers/login', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ resellerId, password })
    });

    const data = await response.json();

    if (!response.ok) {
      alert(data.message || 'Login failed');
    } else {
      alert('Login successful!');

      // ✅ Store entire reseller object
      localStorage.setItem('reseller', JSON.stringify(data.reseller));
      
      // ✅ Also store specific fields for easy access
      localStorage.setItem('resellerId', data.reseller.resellerId);
      localStorage.setItem('resellerName', data.reseller.name);
      localStorage.setItem('profileImageUrl', data.reseller.profileImage); // if available

      navigate('/reseller-dashboard');
    }

  } catch (err) {
    console.error(err);
    alert('Server error');
  }
};


  return (<>
  <Navbar />
    <Container maxWidth="sm" sx={{ mt: 4, mb: 4 }}>
      <Paper elevation={6} sx={{ mt: 8, borderRadius: 3, overflow: 'hidden' }}>
        <Box sx={{ backgroundColor: PRIMARY_COLOR, py: 3, textAlign: 'center' }}>
          <Typography variant="h5" fontWeight="bold" color="white">
            Reseller Login
          </Typography>
        </Box>

        <Box component="form" onSubmit={handleLogin} sx={{ p: 4, backgroundColor: '#f9f9f9' }}>
          <Grid container spacing={3} justifyContent="center">

            {/* Reseller ID */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Reseller ID"
                name="resellerId"
                value={formData.resellerId}
                onChange={handleChange}
                required
                variant="outlined"
                sx={{ width: '290px' }}
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <BadgeIcon sx={{ color: PRIMARY_COLOR }} />
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            {/* Password */}
            <Grid item xs={12}>
              <TextField
                fullWidth
                label="Password"
                name="password"
                type={showPassword ? 'text' : 'password'}
                value={formData.password}
                onChange={handleChange}
                required
                variant="outlined"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <LockIcon sx={{ color: PRIMARY_COLOR }} />
                    </InputAdornment>
                  ),
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={togglePasswordVisibility} edge="end">
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  )
                }}
              />
            </Grid>

            {/* Error Message */}
            {error && (
              <Grid item xs={12}>
                <Typography color="error" align="center">
                  {error}
                </Typography>
              </Grid>
            )}

        {/* Login Button */}
<Grid item xs={12} textAlign="center">
  <Button
    type="submit"
    variant="contained"
    size="large"
    sx={{
      px: 8,
      py: 1.5,
      fontWeight: 'bold',
      backgroundColor: PRIMARY_COLOR,
      borderRadius: 2,
      ':hover': {
        backgroundColor: '#1A252F'
      }
    }}
  >
    Login
  </Button>
</Grid>

{/* Signup Link */}
<Grid item xs={12} textAlign="center" mt={1}>
  <Typography variant="body2">
    Don’t have an account?{' '}
    <Button
      variant="text"
      sx={{ textTransform: 'none', color: PRIMARY_COLOR, fontWeight: 'bold' }}
      onClick={() => navigate('/reseller-register')}
    >
      Create your account
    </Button>
  </Typography>
</Grid>


          </Grid>
        </Box>
      </Paper>
    </Container>
    </>
  );
};

export default ResellerLoginPage;
